import type { ReactNode, FunctionComponent } from 'react';

import classNames from 'classnames';
import Icon, { icons } from './Icon';
import { ICON_SIZE } from './Icon/icon-constants';
import type { IconClassName } from './Icon';

export const INFO_PANEL_TYPE = {
  INFO: 'info',
  WARNING: 'warning',
} as const;

type InfoPanelProps = {
  /**
   * The panel text/body.
   */
  children: ReactNode | string;
  /**
   * Icon to pass in to the panel @default icons.infoCircle
   */
  icon?: IconClassName;
  /**
   * If the panel is Info or a Warning @default 'info'
   */
  type?: 'info' | 'warning';
};

/**
 * A panel that displays call to action info to the user.
 * An icon precedes the passed in children, that defaults to infoCircle
 */
const InfoPanel: FunctionComponent<InfoPanelProps> = ({
  children,
  type = 'info',
  icon = icons.infoCircle,
}) => (
  <div className={classNames('generic__info-panel', {
    'generic__info-panel--info': type === INFO_PANEL_TYPE.INFO,
    'generic__info-panel--warning': type === INFO_PANEL_TYPE.WARNING,
  })}>
    <div className="margin-right-lg">
      <span className="generic__info-panel__icon">
        <Icon icon={icon} size={ICON_SIZE.LG} />
      </span>
    </div>
    <div>
      {children}
    </div>
  </div>
);

export default InfoPanel;
